import Items from '../components/item'
import Loading from 'vue-loading-overlay'

export default {
  Items,
  Loading
}



// WEBPACK FOOTER //
// ./src/app/tenant/access/index/resources/components.js